var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ResoureBanner"},_vm._l((_vm.channels),function(channel,index){return _c('img',{key:index,staticClass:"img flex flex-grow pointer",attrs:{"src":channel.pic},on:{"click":function($event){return _vm.linkTo(channel)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }